import { createActionCreator, createDeltaActionType, createSignalAction } from '../../../setup-react';

// ===== Signals ============================================================ //

// Stats
export const FETCH_STATS_HIGHS = createSignalAction( 'statspro', 'FETCH_STATS_HIGHS' );

// ===== Deltas ============================================================= //

// Stats
export const SET_ROUND_HIGHS = createDeltaActionType( 'statspro', 'SET_ROUND_HIGHS' );
export const setStatsHighs = createActionCreator( SET_ROUND_HIGHS );

export const SET_SEASON_HIGHS = createDeltaActionType( 'statspro', 'SET_SEASON_HIGHS' );
export const setSeasonHighs = createActionCreator( SET_SEASON_HIGHS );